module.exports = __webpack_public_path__ + "static/media/b7.4dc5843.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dengyunze/b7.mp3
// module id = JrIs
// module chunks = 0